import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsHingesValue = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.hinges.value;

export const value = setCalculationModeAdminSettingsHingesValue(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_HINGES_VALUE',
  { value: '', label: '' }
);
